import { render, staticRenderFns } from "./SingleItemContentLinks.vue?vue&type=template&id=4a0f6dc4&"
import script from "./SingleItemContentLinks.vue?vue&type=script&lang=js&"
export * from "./SingleItemContentLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports